
import { defineComponent, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { preventBodyScroll } from '@/utils/utils'

export default defineComponent({
    name: 'mainPage',
    emits: ['backdropClick', 'flicked', 'drag', 'dragStop'],
    props: {
        opened: Boolean,
    },
    setup() {
        let styleTag: HTMLStyleElement | null = null

        const { locale } = useI18n()

        onMounted(() => {
            styleTag = preventBodyScroll()
        })

        onUnmounted(() =>
            // Wait animation to finish, otherwise it jumps because of the scrollbar:
            setTimeout(() => {
                styleTag?.remove()
                styleTag = null
            }, 500),
        )

        return {
            locale,
        }
    },
})
